const imageClassHandler = (image) => {
    if (!image)
        return;
    const newImage = new Image();
    newImage.src = image?.src || '';
    newImage.onload = () => {
        if (image.parentElement === null)
            return;
        image.parentElement.classList.add('spv-campaignPage__media');
        if (newImage.width > newImage.height) {
            image.parentElement?.classList.add('spv-campaignPage__media--horizontal');
        }
        else {
            image.parentElement?.classList.add('spv-campaignPage__media--vertical');
        }
    };
};
const changeImageClass = (imgItems) => {
    imgItems.forEach(item => {
        const img = item.querySelector('img');
        imageClassHandler(img);
    });
};
export const carouselAnimationSetup = (gsap, ScrollTrigger) => {
    return window.addEventListener('DOMContentLoaded', () => {
        console.debug('Carousel script loaded');
        const carousels = document.querySelectorAll('.spv-campaignPage__img-group-container');
        if (!carousels)
            return;
        carousels.forEach(carousel => {
            const imgGroup = carousel.querySelector('.spv-campaignPage__img-group');
            const imgItems = carousel.querySelectorAll('.spv-campaignPage__image-container');
            changeImageClass(imgItems);
            const mm = gsap.matchMedia();
            mm.add('(min-width: 768px)', () => {
                if (imgGroup === null)
                    return;
                const windowWidth = window.innerWidth;
                const windowWidthFactor = windowWidth < 1280 ? 90 : 50;
                const windoweEndFactor = windowWidth < 1280 ? 0 : 50;
                const totalWidth = imgItems.length * windowWidthFactor;
                imgGroup.style.width = totalWidth + windowWidthFactor + 'vw';
                ScrollTrigger.create({
                    trigger: carousel,
                    start: 'top top',
                    end: () => `bottom bottom`,
                    scrub: 1,
                    animation: gsap.fromTo(imgGroup, {
                        x: '16.5vw',
                        ease: 'none',
                    }, {
                        x: () => -(totalWidth - windoweEndFactor) + 'vw',
                        ease: 'none',
                    }),
                });
            });
        });
    });
};
//# sourceMappingURL=carousel.js.map